/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Bypasstwowaysvalve3Inputs */



/**
* | output |
* | --- |
* | "Bypass two-way valve" |
*
* @param {Br_History_Key_Bypasstwowaysvalve3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_bypasstwowaysvalve3 = /** @type {((inputs?: Br_History_Key_Bypasstwowaysvalve3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Bypasstwowaysvalve3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Bypass two-way valve")
	return /** @type {LocalizedString} */ ("Vanne 2 voies by-pass")
});
export { br_history_key_bypasstwowaysvalve3 as "br_history_key_bypassTwoWaysValve" }